export enum IncomingCommand {
  CONVERSATION_CREATE = 'conversation:new',
  CONVERSATION_DELETE = 'conversation:delete',
  CONVERSATION_UPDATE = 'conversation:edit',
  CONVERSATION_TYPING = 'conversation:typing',
  GROUP_CREATE = 'group:new',
  GROUP_DELETE = 'group:delete',
  GROUP_UPDATE = 'group:edit',
  MESSAGE_CREATE = 'message:new',
  MESSAGE_UPDATE = 'message:edit',
  REACTION_UPDATE = 'reaction:new',
  SOCKET_CLOSE = 'socket:close',
  SOCKET_OPEN = 'socket:open',
  SOCKET_RECONNECT = 'socket:reconnect',
  SUBSCRIPTION_PAYMENT_ACTION_REQUIRED = 'subscription:paymentActionRequired',
}

export enum OutgoingCommand {
  BROADCAST = 'send',
  CONVERSATION_JOIN = 'join',
  CONVERSATION_LEAVE = 'leave',
  CONVERSATION_TYPING = 'conversation:typing',
}
